export enum TipoPais {
  MEXICO_ID = '143',
  MEXICO_DESC = 'México',
}
